import React from 'react';

import ArrowIcon from '@swf/core/assets/icons/arrow.svg';

import panelStyles from '../PanelItem/PanelItem.scss';

const PanelItemInfo: React.FC = ({ children }) => (
  <>
    <ArrowIcon className={panelStyles.arrow} />
    <div className={panelStyles.info}>{children}</div>
  </>
);

export default PanelItemInfo;
